import React, { useEffect, useState } from "react";
import { Loader2, ChevronDown } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { Card } from "@/components/ModulePage";

export default function Faq() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/faqs").then(({ data }) => setRows(data)).catch(() => {}).finally(() => setLoading(false)); }, []);
  const filtered = rows.filter((r) => (r.question + r.answer).toLowerCase().includes(q.toLowerCase()));
  const raCtx = "Knowledge center. " + rows.slice(0, 6).map((r) => `${r.question} ${r.answer}`).join(" ");

  return (
    <div>
      <PageHeader title="Help / Knowledge Center" subtitle="Searchable FAQs on the sandbox, use cases, RAG, agents, security, governance, audit and voice AI." readAloudContext={raCtx} />
      <Card>
        <input data-testid="faq-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search FAQs…" className="mb-4 w-full rounded-xl border border-border bg-background px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-ring" />
        {loading ? <div className="flex justify-center py-8"><Loader2 className="h-5 w-5 animate-spin" /></div> : (
          <div className="space-y-2">
            {filtered.map((r, i) => (
              <div key={i} data-testid={`faq-${i}`} className="rounded-xl border border-border">
                <button onClick={() => setOpen(open === i ? null : i)} className="flex w-full items-center justify-between gap-2 px-4 py-3 text-start text-sm font-medium">
                  {r.question} <ChevronDown className={`h-4 w-4 shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
                </button>
                {open === i && <div className="border-t border-border px-4 py-3 text-sm text-muted-foreground">{r.answer}</div>}
              </div>
            ))}
            {filtered.length === 0 && <p className="py-8 text-center text-muted-foreground">No matching FAQs</p>}
          </div>
        )}
      </Card>
    </div>
  );
}
